"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetReferralRewardThresholdsResponseAllOfToJSON = exports.GetReferralRewardThresholdsResponseAllOfFromJSONTyped = exports.GetReferralRewardThresholdsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetReferralRewardThresholdsResponseAllOfFromJSON(json) {
    return GetReferralRewardThresholdsResponseAllOfFromJSONTyped(json, false);
}
exports.GetReferralRewardThresholdsResponseAllOfFromJSON = GetReferralRewardThresholdsResponseAllOfFromJSON;
function GetReferralRewardThresholdsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referralRewardThresholds': (json['referralRewardThresholds'].map(_1.ReferralRewardThresholdFromJSON)),
    };
}
exports.GetReferralRewardThresholdsResponseAllOfFromJSONTyped = GetReferralRewardThresholdsResponseAllOfFromJSONTyped;
function GetReferralRewardThresholdsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'referralRewardThresholds': (value.referralRewardThresholds.map(_1.ReferralRewardThresholdToJSON)),
    };
}
exports.GetReferralRewardThresholdsResponseAllOfToJSON = GetReferralRewardThresholdsResponseAllOfToJSON;
